// ===============================================
// 📡 CONFIGURAÇÃO DA API - INHOLDING
// ===============================================
// Arquivo: src/services/api.js

import axios from 'axios';

// Detectar se está acessando via rede ou localhost
const getApiBaseUrl = () => {
  // PRIORIDADE 1: Se há uma variável de ambiente definida, usar ela
  // Isso permite configurar a URL da API em produção (Vercel) ou desenvolvimento
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // PRIORIDADE 2: Detectar o host atual para redes locais
  const currentHost = window.location.hostname;

  // Se está acessando via IP da rede, usar o mesmo IP para a API
  if (currentHost === '192.168.10.11') {
    return 'http://192.168.10.11:5000/api';
  } else if (currentHost === '192.168.10.121') {
    return 'http://192.168.10.121:5000/api';
  } else if (currentHost !== 'localhost' && currentHost !== '127.0.0.1') {
    return `http://${currentHost}:5000/api`;
  }

  // PRIORIDADE 3: Fallback para localhost
  return 'http://localhost:5000/api';
};

// Configuração base do Axios
const baseURL = getApiBaseUrl();

const api = axios.create({
  baseURL: baseURL,
  timeout: 60000, // Aumentado para 60 segundos
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Adicionado para permitir envio de cookies e credenciais
});

// ===============================================
// 🔧 INTERCEPTORS
// ===============================================

// Request interceptor - adicionar token automaticamente
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Debug em desenvolvimento
    if (process.env.REACT_APP_DEBUG_MODE === 'true') {
    }
    
    return config;
  },
  (error) => {
    console.error('❌ Erro no request:', error);
    return Promise.reject(error);
  }
);

// Response interceptor - tratar respostas e erros
api.interceptors.response.use(
  (response) => {
    // Debug em desenvolvimento
    if (process.env.REACT_APP_DEBUG_MODE === 'true') {
    }
    
    return response;
  },
  (error) => {
    console.error('❌ Erro na API:', error);

    // Token expirado ou inválido - APENAS 401 desloga
    if (error.response?.status === 401) {
      // Não redirecionar se já está na página de login
      if (window.location.pathname.includes('/login')) {
        return Promise.reject(error);
      }

      // Verificar se é uma chamada de API (não login) e apenas mostrar erro
      const requestUrl = error.config?.url || '';
      const isLoginRequest = requestUrl.includes('/auth/login');
      
      if (!isLoginRequest) {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user_data');
        
        // Aguardar um momento antes de redirecionar para permitir que toast de erro apareça
        setTimeout(() => {
          if (!window.location.pathname.includes('/login')) {
            window.location.href = '/login';
          }
        }, 1500);
      }
    }

    // 403 (Forbidden) - Usuário autenticado mas sem permissão
    // NÃO redireciona, apenas retorna o erro para o componente tratar

    return Promise.reject(error);
  }
);

export default api;
